// Copyright 2022 Merit International Inc. All Rights Reserved

export class UnreachableCaseError extends Error {
  public constructor(value: never) {
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    super(`Unreachable case: ${value}`);
  }
}
